import type { FaireProductEntity } from "../../entity_types/product";

export const p_cv7af574: FaireProductEntity = {
  token: "p_cv7af574",
  type: "product",
  name: "Therapeutic Grade Essential Oils",
  brandToken: "b_i2w3l6b8",
  brandName: "Rock Bottom Soap",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/25052b0876a955a767197a6309a64b00e00d9099a23c77de00eb51f80665f056/1537225494.jpg",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/6e6b59451a439de3899e39bb57ffcb705d293ace545a97e35e8c2ae04a7aebc2/1537225492.jpg",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/839f78be28a18ad4674b5b3ff8f80667ca50c87a9e47d6563fed70e422951518/1537225492.jpg",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/72726badaf021a5bd6a51b4ec8259e1e8d5baf3610104fc656637c53e47489d4/1537225492.jpg",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/e7bff0f619dac12ff1feea8fd4c0e49617763c5ea2b9428d1213ef6e5e8c4e74/1537225494.jpg",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/7f28588d1c2742ec63f4eb229f7f54fedf2da87b7bb10a13b9e9ff6bc9a3e14c/1537225494.jpg",
  ],
  priceDollars: 9.7,
  description:
    "1 oz vials with dropper of therapeutic grade essential oils. Perfect for both diffusing or applying topically!\n\nTHESE DO NOT HAVE THE DROPPERS ANY MORE.  THEY HAVE THE TYPICAL ESSENTIAL OIL CAPS.  THE OILS WERE SO STRONG THEY WERE AFFECTING THE RUBBER ON THE DROPPER MAKING A BIG MESS. ",
  tags: [],
  msrpDollars: 19.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:39.778Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
